<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18.3264 3.46084C19.4728 3.59389 20.3125 4.58229 20.3125 5.73644V21.875L12.5 17.9688L4.6875 21.875V5.73644C4.6875 4.58229 5.52717 3.59389 6.67363 3.46084C8.58496 3.23903 10.5292 3.125 12.5 3.125C14.4708 3.125 16.415 3.23903 18.3264 3.46084Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBookmarkEmpty',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		backColor: {
			type: String,
			default: 'transparent',
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
